<div [attr.id]="'vimeo-player-'+media?.id" class="vimeo-player" *ngIf="ready" [ngStyle]="{'height': size + 'px'}"></div>

<div class="vimeo-not-ready" *ngIf="!ready">
    <div class="">{{ 'words.vimeo-process' | translate }}</div>
</div>
